export const FETCH_ATTENDANCE_PERIOD = "FETCH_ATTENDANCE_PERIOD";
export const CREATE_ATTENDANCE_PERIOD = "CREATE_ATTENDANCE_PERIOD";
export const DELETE_ATTENDANCE_PERIOD = "DELETE_ATTENDANCE_PERIOD";
export const FETCH_ATTENDANCE_DDL = "FETCH_ATTENDANCE_DDL";
